import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentCreate from 'material-ui/svg-icons/content/create';

const styles = {
    icon: {overflow: 'inherit'},
};

const EditButtonByCustomKey = ({basePath = '', customKey = '', record = {}}) => (
    <IconButton
        containerElement={<Link to={`${basePath}/${record[customKey]}`}/>}
        style={styles.icon}
    >
        <ContentCreate color={FuseTheme.palette.primary1Color}/>
    </IconButton>
);

EditButtonByCustomKey.propTypes = {
    basePath: PropTypes.string,
    customKey: PropTypes.string,
    record: PropTypes.object,
};

EditButtonByCustomKey.defaultProps = {
    style: {padding: 0},
};

export default EditButtonByCustomKey;


// WEBPACK FOOTER //
// ./src/Fuse/buttons/EditButtonByCustomKey.js